import { useQuery } from '@tanstack/react-query';

import { sortByObjectKey } from '@utils/collections';

import {
  TasklistTemplate,
  TasklistTemplateWithMaybeIds,
  TasklistTemplateWithoutIds,
} from 'types/templates';

import { unhandledRequest } from '../request';

export function useTasklistTemplates() {
  return useQuery({
    queryKey: ['tasklist-templates'],
    staleTime: 1000 * 60,
    queryFn: async () => {
      const response = await unhandledRequest.get<Array<TasklistTemplate>>({
        url: '/tasklists/',
      });

      return response.data.map((template) => {
        return {
          ...template,
          items: sortByObjectKey(template.items, 'order'),
        };
      });
    },
  });
}

export async function deleteTasklistTemplate(id: number) {
  const response = await unhandledRequest.delete<void>({
    url: `/tasklists/${id}/`,
  });

  return response.data;
}

export async function updateTasklistTemplate(data: TasklistTemplateWithMaybeIds) {
  const response = await unhandledRequest.patch<TasklistTemplate>({
    url: `/tasklists/${data.id}/`,
    data,
  });

  return response.data;
}

export async function createTasklistTemplate(data: TasklistTemplateWithoutIds) {
  const response = await unhandledRequest.post<TasklistTemplate>({
    url: `/tasklists/`,
    data,
  });

  return response.data;
}
